var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',{staticClass:"w-full items-center-center"},[_c('button',{staticClass:"w-full",on:{"click":_vm.openModal}},[_vm._v("\n    "+_vm._s(_vm.$t('component.RenderCargaBarcode.label'))+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }